// Makes zod's v4 core types nameable in the emitted declarations: better-auth
// 1.6 surfaces them in its inferred types, and without this tsc fails with
// TS2742 ("cannot be named without a reference to .pnpm/zod@…/v4/core").
import { adminClient, organizationClient } from "better-auth/client/plugins";
import { createAuthClient as createBetterAuthClient } from "better-auth/react";
// Also the source of the exported client types: baseURL does not affect the
// type, so this doubles as a nameable stand-in for the real client.
// jwtClient() is deliberately absent: nothing in the apps calls its actions,
// and its 1.6 types no longer satisfy BetterAuthClientPlugin. The server keeps
// the jwt plugin, so /api/auth/jwks is still served.
const baseClient = createBetterAuthClient({
  baseURL: "http://localhost",
  plugins: [adminClient(), organizationClient()]
});

/**
 * Derived from `baseClient` rather than `ReturnType<typeof createAuthClient>`.
 *
 * With the return type left inferred, anything consuming the client had to name
 * a type living under `packages/auth/node_modules/better-auth/dist/shared/…`,
 * which is not portable from an app (TS2742). It only surfaced when
 * @repo/auth's emitted declarations changed, so it sat hidden behind the turbo
 * cache until an unrelated edit invalidated it.
 */

export const createAuthClient = ({
  apiBaseUrl
}) => {
  const client = createBetterAuthClient({
    baseURL: apiBaseUrl,
    plugins: [adminClient(), organizationClient()],
    fetchOptions: {
      credentials: "include"
    }
  });
  return client;
};
export const authErrorCodes = {
  USER_ALREADY_EXISTS: "E-postadressen är redan registrerad",
  INVALID_EMAIL_OR_PASSWORD: "Fel e-postadress eller lösenord",
  INVALID_PASSWORD: "Felaktigt lösenord",
  USER_NOT_FOUND: "Användaren hittades inte",
  INVALID_TOKEN: "Ogiltig eller utgången länk",
  EMAIL_NOT_VERIFIED: "E-postadressen är inte verifierad"
};
export const getErrorMessage = code => {
  if (code && code in authErrorCodes) {
    return authErrorCodes[code] || "Ett okänt fel har uppstått";
  }
  return "Ett okänt fel har uppstått";
};